import { BiteUrl } from '@biteinc/common';
import { BadgeCategory, BadgeCategoryWarningType, ModelType } from '@biteinc/enums';
import { badgeSchema } from '@biteinc/schemas';

app.Badge = app.AbstractModel.extend({
  ModelName: 'badge',
  Schema: badgeSchema,
  Type: ModelType.Badge,

  defaults() {
    return {
      menuId: app.menu.id,
    };
  },

  isSynced() {
    if (!this.get('integrations')?.length) {
      return false;
    }
    const posI9n = app.location?.getFullPosI9n();
    return !!posI9n?.get('syncBadges');
  },

  canBeManaged() {
    return !this.isSynced() && app.AbstractModel.prototype.canBeManaged.apply(this, arguments);
  },

  canBeDestroyed() {
    return !this.isSynced() && app.AbstractModel.prototype.canBeDestroyed.apply(this, arguments);
  },

  isMissingImages() {
    return !this.hasArr('icons');
  },

  getFieldCollection(field, subProperty, _includeAllValues, _keyModel) {
    const fieldName = subProperty ? [subProperty, field].join('.') : field;
    switch (fieldName) {
      case 'filterCategory':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: BadgeCategory,
          nameGenerator: (filterCategory) => {
            switch (filterCategory) {
              case BadgeCategory.Restrictive:
                return 'Restrictive';
              case BadgeCategory.Dietary:
                return 'Dietary';
              case BadgeCategory.Other:
                return 'Other';
              case BadgeCategory.Hidden:
                return 'Hidden';
              case BadgeCategory.NonFiltering:
                return 'Non-Filtering';
              case BadgeCategory.Warning:
                return 'Warning';
              default:
                throw new Error(`unrecognized filterCategory value: ${filterCategory}`);
            }
          },
        });
      case 'warningType':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: BadgeCategoryWarningType,
          nameGenerator: (warningType) => {
            switch (warningType) {
              case BadgeCategoryWarningType.HighSugar:
                return 'High Sugar';
              case BadgeCategoryWarningType.HighSodium:
                return 'High Sodium';
              default:
                throw new Error(`unrecognized warningType value: ${warningType}`);
            }
          },
        });
    }
    return null;
  },

  displayNameHtml() {
    let title = '';
    if (this.isMissingImages()) {
      title +=
        '<img class="badge-img" src="https://static.bureau.getbite.com/images/no-photo.png" ' +
        'srcset="https://static.bureau.getbite.com/images/no-photo@2x.png 2x" title="No Photos"/>';
    } else {
      const url = BiteUrl.biteAssetUrlWithNewHost(this.get('icons')[0].url);
      title += `<img class="badge-img" src="${url}"/>`;
    }
    title += `<span>${this.displayName()}</span>`;

    return title;
  },
});
